// extracted by mini-css-extract-plugin
export default {"container":"Legend_container__iJ9qx","left_container":"Legend_left_container__4kKvN","right_container":"Legend_right_container__dGEQ7"};